module.exports = __webpack_public_path__ + "_assets/img/empty-doc.0d45be8a.svg";